import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {HawalaBranchesListFilter} from './HawalaBranchesListFilter'

const HawalaBranchesListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddHawalaBranchModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-hawala_branch-table-toolbar='base'>
      <HawalaBranchesListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add hawala_branch */}
      <button type='button' className='btn btn-primary' onClick={openAddHawalaBranchModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='HAWALABRANCH.TABLE.CREATEHAWALABRANCH' defaultMessage={"ایجاد نماینده گی صرافی"}/>
      </button>
      {/* end::Add hawala_branch */}
    </div>
  )
}

export {HawalaBranchesListToolbar}
